export * from "modules/TyreDiscountsDashboard/components/TyreDiscountsTable/hooks/useCategoriesQuery";
export * from "modules/TyreDiscountsDashboard/components/TyreDiscountsTable/hooks/useDiscountsQuery";
export * from "modules/TyreDiscountsDashboard/components/TyreDiscountsTable/hooks/useTyreBrandsQuery";
